import { render, staticRenderFns } from "./RecoveryConfirm.vue?vue&type=template&id=1215add0&scoped=true&"
import script from "./RecoveryConfirm.vue?vue&type=script&lang=js&"
export * from "./RecoveryConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryConfirm.vue?vue&type=style&index=0&id=1215add0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215add0",
  null
  
)

export default component.exports